import { FileFormat } from '../../../shared/types/resultsDownload';

export const fileFormatsResultsDownload = [FileFormat.json];

export const fileFormatEntryDownload = [FileFormat.rdfXml, FileFormat.json];
